import { getRecipeQL } from '@libs/search-service-smart-search';
import type {
  ItinerarySearchUserCriteria,
  IngredientQL,
} from '@libs/trip-planner-interfaces';
import {
  AvailabilityOrderQL,
  IngredientTypeQL,
  SelectedHotelTypeQL,
} from '@libs/trip-planner-interfaces';

export function getRecipeForShareWidget(
  userCriteria: ItinerarySearchUserCriteria,
  affiliateId: string | undefined
): string {
  const recipe = getRecipeQL({
    userCriteria,
    businessCriteria: {
      affiliateId,
    },
  });

  delete recipe.sessionId;
  delete recipe.metadata;

  recipe.ingredients = recipe.ingredients.map((ingredient: IngredientQL) => {
    if (ingredient.ingredientType === IngredientTypeQL.Hotel) {
      delete ingredient.numberOfSuggestions;
      if (hasAllHotelTypesSelected(ingredient.selectedHotelTypes)) {
        ingredient.selectedHotelTypes = [];
      }
    }

    if (
      'suggestedBy' in ingredient &&
      ingredient.suggestedBy === AvailabilityOrderQL.RelativeWeight
    ) {
      ingredient.suggestedBy = AvailabilityOrderQL.Popular;
    }

    return ingredient;
  });

  return JSON.stringify({
    recipe,
  });
}

function hasAllHotelTypesSelected(
  selectedHotelTypes: SelectedHotelTypeQL[]
): boolean {
  const hotelTypesAmount = 3;
  return (
    selectedHotelTypes.includes(SelectedHotelTypeQL.Hotel) &&
    selectedHotelTypes.includes(SelectedHotelTypeQL.Apartment) &&
    selectedHotelTypes.includes(SelectedHotelTypeQL.HouseOrCottage) &&
    selectedHotelTypes.length === hotelTypesAmount
  );
}
